<app-generic-container>
  <!-- Usamos el panel genérico -->

  <app-generic-panel [title]="this.isNew ? panelTitle : panelTitleTwo"
    [description]="this.isNew ? panelDescription : panelDescriptionTwo" [icon]="panelIcon">

    <div *ngIf="loadingData" class="d-flex justify-content-center align-items-center loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
    </div>
    <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="null" #appConpanyNewForm="ngForm"
      novalidate="">
      <div class="row" *ngIf="this.isNew || appA3DocDocumentModel.title">
        <div class="col-sm-14 col-lg-8">
          <div class="row justify-content-center">

            <div class="col-12 ml-2">
              <div class="block">

                <legend class="pl-0 mt-2">Datos del documento</legend>

                <app-form-input-app [labelText]="'Nombre del documento'" [isRequired]="true">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="appA3DocDocumentModel.title "
                    (ngModelChange)="setDocumentName($event)" name="DocumentName">
                  <small *ngIf="!documentNameValid" class="text-danger">
                    Este campo es obligatorio
                  </small>
                </app-form-input-app>


                <div [ngClass]="{'mt-2': !this.isNew, 'mt-4': this.isNew}">
                  <app-form-input-app *ngIf="!this.isNew" [labelText]="'Empresa'" [isRequired]="true">
                    <input class="form-control" autocomplete="off" type="text"
                      [(ngModel)]="appA3DocDocumentModel.customerName" name="CompanyName" readonly>
                  </app-form-input-app>

                  <app-dropdown-formularios *ngIf="this.isNew" dataSize="7" placeHolder="Empresa" [selectedValue]=""
                    (selectedValueChange)="companySelectedChanged($event)" [required]="true"
                    [disabled]="a3docCompany == null" [dropdownType]="'Companies'" [detailedData]="true">
                  </app-dropdown-formularios>
                </div>
                <div class="row">
                  <div class="col-6">
                    <app-form-input-app [labelText]="'Fecha de creación'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [ngModel]="appA3DocDocumentModel.date || a3docCreatedAt && getFormattedDate(a3docCreatedAt)"
                        (ngModelChange)="setCreatedAt($event)" name="CreatedOn" readonly>
                    </app-form-input-app>
                  </div>
                  <div class="col-6" [ngClass]="{'mt-1': this.isNew}">
                    <app-dropdown-formularios *ngIf="this.isNew" dataSize="7" placeHolder="Categoría"
                      [selectedArrayValue]="appA3DocDocumentModel.containersId|| a3docCategory "
                      (selectedValueChange)="setCategory($event)" [required]="true"
                      [companySelected]="a3docCompany.identifier" [disabled]="!a3docCompany.identifier"
                      [dropdownType]="'DocCategories'">
                    </app-dropdown-formularios>

                    <app-form-input-app *ngIf="!this.isNew" [labelText]="'Categoría'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [ngModel]="appA3DocDocumentModel.containersNames" (ngModelChange)="setCategory($event)"
                        name="CreatedOn" readonly>
                    </app-form-input-app>
                  </div>
                </div>


              </div>
            </div>


          </div>

        </div>
        <div class="col-sm-12 col-lg-4 d-flex justify-content-center align-items-center">
          <div class="row" *ngIf="this.isNew">
            <!-- si queremos que se edite tenemos que añadir esto : || appA3DocDocumentModel.docData -->
            <div class="col-8">
              <input type="file" #fileInput accept=".pdf" style="display: none" (change)="onFileSelected($event)" />
              <button class="btn btn-fill btn-primary w-100" (click)="fileInput.click()"
                [disabled]="loading">SELECCIONAR DOCUMENTO</button>
            </div>
            <div class="col-8 mt-2">
              <button class="btn btn-fill w-100"
                (click)="appA3DocDocumentModel.docData|| documentData ? onFileOpen(): null"
                [disabled]="!documentData && !appA3DocDocumentModel.docData">VER DOCUMENTO</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row col-12 float-right " *ngIf="this.isNew || appA3DocDocumentModel.title">
        <label class="col-12"></label>
        <div class="col-12">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-primary float-right" [disabled]="!appConpanyNewForm.valid"
              (click)="onPublishClick()" [disabled]="loading">{{sendButton}}</button>
            <a class="btn btn-fill btn-outline-white float-right" [routerLink]="loading ? null : '../'"
              [class.disabled]="loading">Volver</a>
          </div>
        </div>
      </div>

    </form>
  </app-generic-panel>

  <app-generic-panel *ngIf="!this.isNew" [title]="panelTitleThree" [description]="panelDescriptionThree"
    [icon]="panelIconTwo">

    <div *ngIf="loadingData" class="d-flex justify-content-center align-items-center loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
    </div>

    <app-documentos-usuarios-list [subjectID]="model.doc1" [company]="appA3DocDocumentModel.customerId"
      (selectedUsers)="onUsersSelectedChange($event)" (deleteUsers)="onDeleteUser($event)"
      [usersSelectedNif]="a3docUsersSelected" [documentReaders]="a3docReaders"
      *ngIf="a3docCompany || appA3DocDocumentModel.customerId">
    </app-documentos-usuarios-list>
  </app-generic-panel>
</app-generic-container>